@if (dashboardResource.isLoading()) {
  <app-loading />
} @else {
  @let dashboardData = dashboardResource.value();
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
    <app-summary-card
      icon="pi pi-users"
      iconColor="text-pink-500"
      cardTitle="common.selecthor.admin.activeCustomers"
      [formattedValue]="(dashboardData?.activeCustomers ?? 0).toString()"
    />
    <app-summary-card
      icon="pi pi-folder"
      iconColor="text-(--color-blue)"
      cardTitle="common.selecthor.admin.activeProjects"
      [formattedValue]="(dashboardData?.activeProjects ?? 0).toString()"
    />
    <app-summary-card
      icon="pi pi-check-circle"
      iconColor="text-(--color-green)"
      cardTitle="common.selecthor.admin.completedProjects"
      [formattedValue]="(dashboardData?.completedProjects ?? 0).toString()"
    />
    <app-summary-card
      icon="pi pi-building"
      iconColor="text-amber-500"
      cardTitle="common.selecthor.admin.activeProviders"
      [formattedValue]="(dashboardData?.activeProviders ?? 0).toString()"
    />
  </div>
}
